// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2c2sW","productName":"Table_productName__1HyEB"};